module.exports = __webpack_public_path__ + "b341df4fb12a2254b23c0307ef51a8ad.svg";